// client/src/hooks/useChannelName.js

import { useMemo } from 'react'
import { formatChannelName } from '../utils/chatUtils'

/**
 * Custom hook for channel name formatting
 * @param {Object} channel - The channel object
 * @returns {string} Formatted channel name
 */
export default function useChannelName(channel) {
  return useMemo(() => formatChannelName(channel), [channel])
}